import { Component } from '@angular/core';

@Component({
  selector: 'mprd-modem-choice-voip-skeleton',
  templateUrl: './modem-choice-voip-skeleton.component.html',
})
export class ModemChoiceVoipSkeletonComponent {}
